<template>
<div class="order-body">
    <br/>
    <h4>진행중 목록</h4>
    <div class="table-card" style="overflow: hidden;">
        <div class="table-wrap position-relative">
            <div class="table-spinner-container" v-if="loadingStates.delivering">
                <div class="spinner" />
            </div>
            <a-table
                size="small"
                v-if="invoice.delivering.list.length > 0"
                :scroll="{ x: '2100px' }"
                :columns="columns.delivering"
                :data-source="invoice.delivering.list"
                :pagination="false"
            >
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'btn'">
                        <a-button class="confirm-btn"
                                style="height: 20px"
                                @click="uiHandler.purchaseConfirmation(record._id)"
                        >구매확정
                        </a-button>
                    </template>
                </template>
            </a-table>
            <div class="no-result-container" v-else>
                <div class="no-result-content">
                    <i class="fa-solid fa-exclamation-triangle" v-if="!loadingStates.delivering"/>
                    <span v-if="!loadingStates.delivering">조회 결과가 없습니다.</span>
                </div>
            </div>
        </div>
    </div>

    <br/>
    <h4>배송완료 목록</h4>
    <div class="table-card" style="overflow: hidden;">
        <div class="table-wrap position-relative">
            <div class="table-spinner-container" v-if="loadingStates.completed">
                <div class="spinner" />
            </div>
            <a-table
                size="small"
                v-if="invoice.completed.list.length > 0"
                :scroll="{ x: '2100px' }"
                :columns="columns.completed"
                :data-source="invoice.completed.list"
                :pagination="false"
            >
            </a-table>
            <div class="no-result-container" v-else>
                <div class="no-result-content">
                    <i class="fa-solid fa-exclamation-triangle" v-if="!loadingStates.completed"/>
                    <span v-if="!loadingStates.completed">조회 결과가 없습니다.</span>
                </div>
            </div>
        </div>
    </div>
    <pagination 
        :page-info="paging"
        :page-name="serverEnum.orderStatus.Completed"
        @change-page="paging.changePageListener"
    />
</div>
</template>

<script>
import { serverEnum } from '../server-enum'

export default {
    name: 'DeliveryManagement',
    props: {
        loadingStates: {
            type: Object,
            required: true
        },
        invoice: {
            type: Object,
            required: true
        },
        paging: {
            type: Object,
            required: true
        },
        searchDelivery: {
            type: Function,
            required: true
        }
    },
    data() {
        const baseColumns = [
            {key: 'index', title: '번호', dataIndex: 'index', align: 'center', fixed: 'left', width: 50},
            {key: 'hospitalName', title: '병원명', dataIndex: 'hospitalName', align: 'center', fixed: 'left', width: 140, ellipsis: true},
            {key: 'orderNo', title: '주문번호', dataIndex: 'orderNo', align: 'center', fixed: 'left', width: 140, ellipsis: true},
            {key: 'orderAt', title: '주문일', dataIndex: 'orderAt', align: 'center', fixed: 'left', width: 160},
            {key: 'umOutKindName', title: '판매유형', dataIndex: 'umOutKindName', align: 'center', width: 100},
            {key: 'deliveryType', title: '배송방식', dataIndex: 'deliveryType', align: 'center', width: 100},
            {
                key: 'deliveryCompany',
                title: '배송회사',
                dataIndex: 'deliveryCompany',
                align: 'center',
                width: 100,
                customRender: ({record}) => {
                    if (record.deliveryNo?.length < 13 && record.deliveryNo !== '-') {
                        return <span>{'일양'}</span>
                    } else if (record.deliveryNo?.length >= 13 && record.deliveryNo !== '-') {
                        return <span>{'우체국'}</span>
                    } else {
                        return <span>{'-'}</span>
                    }
                }
            },
            {
                key: 'deliveryNo',
                title: '운송장',
                dataIndex: 'deliveryNo',
                align: 'center',
                width: 140,
                customRender: ({record}) => {
                    return (
                        <a-row style={{display: 'flex', justifyContent: 'center', justifyItems: 'center'}}>
                            <a-col>
                                <a-row>
                                    <span>{record.deliveryNo || '-'}</span>
                                </a-row>
                                <a-row>
                                    {record.deliveryType === '택배' && record.deliveryNo !== '-' &&
                                        <a-button
                                            style={{height: '10px', width: '100%'}}
                                            onClick={e => this.uiHandler.handleDeliveryInfoModal.open(record?.deliveryNo)}
                                        >
                                            조회
                                        </a-button>
                                    }
                                </a-row>
                            </a-col>
                        </a-row>
                    );
                }
            },
            {
                key: 'deliveryStatus',
                title: '배송상태',
                dataIndex: 'deliveryStatus',
                align: 'center',
                width: 120,
                customRender: ({record}) => {
                    return record.deliveryStatus
                        ? <a-tag class={this.uiHandler.deliveryStatusClass(record)}>
                            <span style={{fontSize: '15px'}}>{record.deliveryStatus}</span>
                          </a-tag>
                        : <span>{'-'}</span>
                }
            },
            {key: 'invoiceNo', title: '인보이스번호', dataIndex: 'invoiceNo', align: 'center', width: 140},
            {key: 'smProgressTypeName', title: '진행상태', dataIndex: 'smProgressTypeName', align: 'center', width: 120},
            {key: 'deptName', title: '지점', dataIndex: 'deptName', align: 'center', width: 120},
            {key: 'empName', title: '담당자', dataIndex: 'empName', align: 'center', width: 100},
            {key: 'qty', title: '주문수량', dataIndex: 'qty', align: 'center', width: 100},
            {key: 'totAmt', title: '단가', dataIndex: 'totAmt', align: 'right', width: 120},
            {key: 'totCurAmt', title: '공급가액', dataIndex: 'totCurAmt', align: 'right', width: 120},
            {key: 'totCurVat', title: '부가세', dataIndex: 'totCurVat', align: 'right', width: 120},
            {
                key: 'remark',
                title: '비고',
                dataIndex: 'remark',
                align: 'center',
                width: 200,
                ellipsis: true
            }
        ];

        // delivering 테이블에는 구매확정 버튼 추가
        const deliveringColumns = [...baseColumns];
        const btnInsertAt = deliveringColumns.findIndex(item => item.key === "deliveryStatus") + 1;
        deliveringColumns.splice(btnInsertAt, 0, {
            key: 'btn',
            title: '구매확정',
            align: 'center',
            width: 100,
            fixed: 'right'
        });

        return {
            serverEnum,
            columns: {
                delivering: deliveringColumns,
                completed: baseColumns
            }
        }
    }
}
</script>

<style scoped>
.confirm-btn {
    background-color: #FFE414;
    border: none;
    padding: 0 8px;
    min-width: 80px;
}

.confirm-btn:hover {
    color: black;
    border: none;
}

:deep(.ant-table-cell) {
    padding: 8px !important;
    white-space: nowrap;
}

.no-result-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    width: 100%;
    
    .no-result-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        color: #8D939A;

        i {
            font-size: 24px;
        }

        span {
            font-size: 14px;
        }
    }
}
</style> 